var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImportImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 323,
    height: 194,
    viewBox: "0 0 323 194",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-609 -352)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M236.354,193.776c28.057,1.978,63.13-9.133,78.6-33.5,6.407-10.088,10.661-23.034,6.2-34.2-3.378-8.453-17.665-18.006-20.751-26.58-3.129-8.693-2.684-18.485-1.077-27.622,4.613-26.26-21.038-67.258-75.216-71.635-41.077-3.317-59.661,28.573-94.623,32.926C94.213,37.56,52.844,11.2,27.6,33.168c-31.34,27.278-16.632,54.579-12.818,67.353,4.9,16.411-19.053,35.139-14.11,59.3,11.043,54.02,91.312,17.591,114.839,15.311,23.9-2.317,47.6,4.478,71.02,9.931s48.216,9.553,71.1,2.069Z",
    transform: "translate(609 352)",
    fill: "#f3faff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M255.04,65.825H102.349a5.982,5.982,0,0,1-5.892-7.019l5.976-33.866A5.982,5.982,0,0,1,108.325,20H261.016a5.982,5.982,0,0,1,5.892,7.019l-5.976,33.866A5.985,5.985,0,0,1,255.04,65.825Z",
    transform: "translate(609 352)",
    fill: "#2b5684",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M127.024,53.495H113.388a2.468,2.468,0,0,1-2.489-3.02l2.4-13.628a3.763,3.763,0,0,1,3.553-3.02h13.636a2.468,2.468,0,0,1,2.489,3.02l-2.4,13.628A3.766,3.766,0,0,1,127.024,53.495ZM116.553,35.553a1.613,1.613,0,0,0-1.523,1.295l-2.4,13.628a1.058,1.058,0,0,0,1.067,1.295h13.636a1.614,1.614,0,0,0,1.523-1.295l2.4-13.628a1.058,1.058,0,0,0-1.068-1.295Z",
    transform: "translate(609 352)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M118.835,49.513a1.073,1.073,0,0,1-.847-.378l-4.383-5.322a1.338,1.338,0,0,1,.322-1.83,1.294,1.294,0,0,1,1.831,0l3.63,4.405L135.524,32.7a1.29,1.29,0,0,1,1.831,0,1.337,1.337,0,0,1-.326,1.83l-17.213,14.6A1.526,1.526,0,0,1,118.835,49.513Z",
    transform: "translate(609 352)",
    fill: "#2b5684"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M236.153,40.3H147.188a1.155,1.155,0,0,1-1.165-1.414,1.758,1.758,0,0,1,1.663-1.414H236.65a1.155,1.155,0,0,1,1.166,1.414A1.76,1.76,0,0,1,236.153,40.3Z",
    transform: "translate(609 352)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M213.754,48.344h-69.23a1.155,1.155,0,0,1-1.165-1.413,1.758,1.758,0,0,1,1.663-1.414h69.233a1.155,1.155,0,0,1,1.166,1.414A1.766,1.766,0,0,1,213.754,48.344Z",
    transform: "translate(609 352)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M234.857,117.412H82.167a5.982,5.982,0,0,1-5.892-7.019l5.976-33.865a5.981,5.981,0,0,1,5.892-4.94h152.69a5.982,5.982,0,0,1,5.892,7.019l-5.976,33.866A5.983,5.983,0,0,1,234.857,117.412Z",
    transform: "translate(609 352)",
    fill: "#2b5684",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M106.841,105.082H93.205a2.468,2.468,0,0,1-2.489-3.019l2.405-13.628a3.764,3.764,0,0,1,3.553-3.02H110.31a2.469,2.469,0,0,1,2.49,3.02l-2.406,13.628A3.766,3.766,0,0,1,106.841,105.082ZM96.37,87.144a1.613,1.613,0,0,0-1.523,1.295l-2.405,13.628a1.059,1.059,0,0,0,1.068,1.295h13.636a1.614,1.614,0,0,0,1.523-1.295l2.4-13.628a1.058,1.058,0,0,0-1.068-1.295Z",
    transform: "translate(609 352)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M98.653,101.1a1.072,1.072,0,0,1-.847-.378L93.422,95.4a1.338,1.338,0,0,1,.322-1.83,1.294,1.294,0,0,1,1.831,0l3.63,4.405,16.135-13.684a1.29,1.29,0,0,1,1.831,0,1.338,1.338,0,0,1-.325,1.83l-17.214,14.6A1.522,1.522,0,0,1,98.653,101.1Z",
    transform: "translate(609 352)",
    fill: "#2b5684"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M225.37,91.892H127.006a1.155,1.155,0,0,1-1.166-1.414,1.759,1.759,0,0,1,1.663-1.413h98.364a1.155,1.155,0,0,1,1.166,1.413A1.762,1.762,0,0,1,225.37,91.892Z",
    transform: "translate(609 352)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M152.839,99.936h-28.5a1.155,1.155,0,0,1-1.166-1.413,1.759,1.759,0,0,1,1.663-1.414h28.5a1.155,1.155,0,0,1,1.166,1.414A1.766,1.766,0,0,1,152.839,99.936Z",
    transform: "translate(609 352)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M172.108,99.936H159.273a1.155,1.155,0,0,1-1.165-1.413,1.758,1.758,0,0,1,1.663-1.414H172.6a1.156,1.156,0,0,1,1.166,1.414A1.76,1.76,0,0,1,172.108,99.936Z",
    transform: "translate(609 352)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M214.671,169H61.984a5.983,5.983,0,0,1-5.892-7.019l5.976-33.865a5.981,5.981,0,0,1,5.892-4.941H220.651a5.983,5.983,0,0,1,5.892,7.019l-5.976,33.866A5.986,5.986,0,0,1,214.671,169Z",
    transform: "translate(609 352)",
    fill: "#2b5684",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M86.655,156.67H73.019a2.468,2.468,0,0,1-2.489-3.02l2.405-13.628A3.764,3.764,0,0,1,76.488,137H90.124a2.468,2.468,0,0,1,2.489,3.019L90.208,153.65A3.763,3.763,0,0,1,86.655,156.67ZM76.187,138.731a1.614,1.614,0,0,0-1.523,1.295l-2.405,13.628a1.058,1.058,0,0,0,1.068,1.294H86.963a1.613,1.613,0,0,0,1.523-1.294l2.405-13.628a1.058,1.058,0,0,0-1.068-1.295Z",
    transform: "translate(609 352)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M78.47,152.688a1.072,1.072,0,0,1-.847-.378l-4.383-5.322a1.338,1.338,0,0,1,.322-1.83,1.3,1.3,0,0,1,1.831,0l3.63,4.4,16.136-13.684a1.291,1.291,0,0,1,1.831,0,1.338,1.338,0,0,1-.326,1.83L79.45,152.31A1.529,1.529,0,0,1,78.47,152.688Z",
    transform: "translate(609 352)",
    fill: "#2b5684"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M195.788,143.479H106.823a1.155,1.155,0,0,1-1.166-1.413,1.761,1.761,0,0,1,1.663-1.414h88.965a1.155,1.155,0,0,1,1.165,1.414A1.762,1.762,0,0,1,195.788,143.479Z",
    transform: "translate(609 352)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M173.389,151.52H104.156a1.155,1.155,0,0,1-1.166-1.414,1.759,1.759,0,0,1,1.663-1.413h69.233a1.155,1.155,0,0,1,1.166,1.413A1.755,1.755,0,0,1,173.389,151.52Z",
    transform: "translate(609 352)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportImg);
export default __webpack_public_path__ + "static/media/importImg.5c78dd5815bfe07fb7d50c760abbef16.svg";
export { ForwardRef as ReactComponent };